export const SECONDARY_TEXT_COLOR = "#626262";
export const ERROR_TEXT_COLOR = "#c62828";
